export const RENEWALS_TYPES = {
  OVERDUE: 'OVERDUE',
  WITHIN_FIRST_PERIOD: 'RENEWAL_1',
  WITHIN_SECOND_PERIOD: 'RENEWAL_2',
  WITHIN_TWO_PERIODS: 'RENEWAL_1_2',
  RENEWED: 'RENEWED',
  NOT_RENEWED: 'NOT_RENEWED'
};
export const PLAN_TYPES = {
  CORPORATE: 'GROUP',
  INDIVIDUAL: 'INDIVIDUAL',
  FINANCIAL: 'FINANCIAL',
};
export const PAYMENT_STATUSES = {
  PENDING: 'PENDING',
  RECEIVED: 'RECEIVED',
  MISSING: 'MISSING'
};
export const TRANSACTION_STATUSES = {
  PENDING: 'PENDING',
  RECEIVED: 'RECEIVED',
  MISSING: 'MISSING',
};
export const RENEWALS_TYPES_INFO = {
  [RENEWALS_TYPES.OVERDUE]: {
    id: RENEWALS_TYPES.OVERDUE,
    name: 'renewals.RenewalOverdue',
    color: 'rgba(205, 38, 38, 1)',
  },
  [RENEWALS_TYPES.WITHIN_FIRST_PERIOD]: {
    id: RENEWALS_TYPES.WITHIN_FIRST_PERIOD,
    name: 'renewals.Within30Days',
    color: 'rgba(173, 122, 255, 1)',
  },
  [RENEWALS_TYPES.WITHIN_SECOND_PERIOD]: {
    id: RENEWALS_TYPES.WITHIN_SECOND_PERIOD,
    name: 'renewals.Within90Days',
    color: 'rgba(19, 128, 255, 1)',
  },
  [RENEWALS_TYPES.RENEWED]: {
    id: RENEWALS_TYPES.RENEWED,
    name: 'renewals.Renewed',
    color: 'rgba(88, 219, 77, 1)',
  },
  [RENEWALS_TYPES.NOT_RENEWED]: {
    id: RENEWALS_TYPES.NOT_RENEWED,
    name: 'renewals.NotRenewed',
    color: 'rgba(199, 199, 199, 1)',
  },
};
export const RENEWALS_LIST = [
  RENEWALS_TYPES.OVERDUE,
  RENEWALS_TYPES.WITHIN_FIRST_PERIOD,
  RENEWALS_TYPES.WITHIN_SECOND_PERIOD,
  RENEWALS_TYPES.RENEWED,
  RENEWALS_TYPES.NOT_RENEWED,
];
export const RENEWALS_PERIODS_FIELD = {
  [RENEWALS_TYPES.WITHIN_FIRST_PERIOD]: 'renewals1',
  [RENEWALS_TYPES.WITHIN_SECOND_PERIOD]: 'renewals2',
};
export const TRANSACTION_STATUSES_TEXTS = {
  [TRANSACTION_STATUSES.PENDING]: 'leads.options.Pending',
  [TRANSACTION_STATUSES.RECEIVED]: 'leads.options.Received',
  [TRANSACTION_STATUSES.MISSING]: 'leads.options.Missing',
};
export const TRIGGER_TYPES = {
  TASK: 'task',
  EMAIL: 'email',
  APP: 'app',
  WHATSAPP: 'whatsapp'
};
